// extracted by mini-css-extract-plugin
export default {"controlRow":"MGInput_controlRow__cPEa4","leftIcon":"MGInput_leftIcon__KSNuQ","rightIcon":"MGInput_rightIcon__a9lEs","rightIconButton":"MGInput_rightIconButton__MUreX"};